module.exports = __webpack_public_path__ + "img/744.f2117ba7.jpg";